import { convertFileToByteArray } from "../../../components/common/FilesHelperUtil";
import { showToastrError } from "../../../util/toastr";
import { getSettings } from "../../../store/configureStore";
import nieuweSportclubApi from "../../../api/nieuweSportclubApi";
import assign from 'object-assign';
import mergeDeep from "../../../util/mergeDeep.js";

export default class OrganisatiePageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        let context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");

        context.setState({
            model: context.props.storeModel
        });
    }

    goToNext() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        ajaxActions.started();
        return nieuweSportclubApi.validateOrganisatie(mergeDeep({}, context.state.model))
            .then((response) => {
                ajaxActions.ended();
                if (!response.data.hasValidationErrors) {
                    context.setState({
                        hasUnsavedChanges: false
                    });
                    this.redirector.goTo("/nieuweSportclub/identificatie");
                }
                else {
                    context.setState({
                        errors: assign({}, response.data.validationResults)
                    });
                }
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = mergeDeep({}, this.context.state.model);
        model[property] = value;

        this.context.setState({
            model,
            nameHasFocus: false
        });
    }

    changeFile(event) {
        const value = event.target.value;
        const property = event.target.name;
        const context = this.context;

        const model = context.state.model;
        const maxAllowedContentLength = Number(getSettings().maxAllowedContentLength) / 2;

        if (value && value.length) {
            if (value[0].size > maxAllowedContentLength) {
                showToastrError("Het '" + value[0].name + "' bestand is te groot. Maximum 100MB per bestand.");
                return;
            }
            convertFileToByteArray(context, value[0], property);
        }
        else {
            model[property] = null;
            context.setState({
                model,
            });
        }
    }

}